import jQuery from 'jquery';
import _ from 'lodash';

import SEGMENT_EVENTS from 'constants/segmentEvents';

function linkify(text) {
  if (text.indexOf('href=') >= 0) return text;

  // const urlRegex = new RegExp(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/, 'ig');
  const urlRegex = '';

  return text.replace(urlRegex, function(url) {
    return `<a href="${url}" target="_blank">${url}</a>`;
  });
}

function imgify(url) {
  return `<img src="${url}" />`;
}

function Ctrl($rootScope, $scope, $timeout, $window, supportService, tlHttp, events, conciergeMessageReceivedKey, tracking) {
  $scope.messages = {};
  $scope.messageText = '';

  $scope.sendMessage = function() {
    if ($scope.isSending) return;
    $scope.isSending = true;

    const text = $scope.messageText || 'Image:';
    const options = {};

    if ($scope.image) {
      options.data = {
        mediaUrl: $scope.image.original
      };
    }

    supportService.sendInboundMessage(text, options).then(success, error);

    function success(resp) {

      tracking.trackEvent(SEGMENT_EVENTS.ContactedConcierge, {
        message: resp.text
      });

      $scope.isSending = false;
      $scope.messageText = '';
      $scope.image = null;
    }

    function error() {
      $scope.isSending = false;

      $timeout(function() {
        window.alert('Failed to send message. Please try again.'); //eslint-disable-line
      }, 200);
    }
  };

  $scope.canSendMessage = function() {
    return !$scope.isSending && ($scope.messageText || $scope.image);
  };

  $scope.$on('new-concierge-message', function(event, args) {
    $scope.messageText = args.text || '';

    if (args.autosend) {
      $scope.sendMessage();
    }
  });

  $scope.fetchMessages = function() {
    if ($scope.loading) return;

    $scope.loading = true;

    const options = {
      limit: 20
    };

    supportService.listClientMessages(options)
      .then(function(result) {
        $scope.messages = _.keyBy(result, 'id');

        $scope.loading = false;

        $timeout(function() {
          scrollToBottom(0);
        }, 100);
      }, function() {
        $scope.loading = false;
      });
  };

  $scope.getMessages = function() {
    return _
      .chain($scope.messages)
      .values($scope.messages)
      .filter(function(message) {
        return !$scope.isInternalMessage(message);
      })
      .value();
  };

  $scope.isInternalMessage = function(message) {
    return message.from.userType === 'agent' && message.to.userType === 'agent';
  };

  $scope.isUserMessage = function(message) {
    return message.from.userType !== 'agent';
  };

  $scope.isAgentMessage = function(message) {
    return message.from.userType === 'agent';
  };

  $scope.getMessageImageUrl = function(message) {
    const info = message.from.info || {};
    return $scope.getClientImageUrl(info);
  };

  $scope.getMessageName = function(message) {
    const info = message.from.info || {};
    return $scope.getClientName(info, message.messageType);
  };

  $scope.getMessageText = function(message) {
    let text = linkify(message.text || '');

    if (message.data && message.data.mediaUrl) {
      text = text.replace('(no text)', '');
      text += imgify(message.data.mediaUrl);
    }
    return text;
  };

  $scope.getClientImageUrl = function(info) {
    return info.imageUrl || 'https://assets.tablelist.com/www/images/user-icon-256.png';
  };

  $scope.getClientName = function(info) {
    if (info.firstName) {
      return info.firstName;
    }
    return 'Anonymous';
  };

  $scope.mediaUrl = function(message) {
    const data = message.data || {};

    return data.mediaUrl || null;
  };

  $scope.bookingUrl = function(message) {
    const data = message.data || {};
    return data.booking ? `/booking/${data.booking}` : null;
  };

  $scope.eventUrl = function(message) {
    const data = message.data || {};
    return data.event ? `/event/${data.event}/inventory` : null;
  };

  $scope.venueUrl = function(message) {
    const data = message.data || {};
    return data.venue ? `/venues/${data.venue}/inventory` : null;
  };

  $scope.cityUrl = function(message) {
    const data = message.data || {};
    return data.city ? `/${data.city}/venues/` : null;
  };

  $scope.removeImage = function() {
    $scope.image = null;

    document.getElementById('input-img-upload').value = '';
  };

  $scope.uploadImage = function(files) {
    if ($scope.uploading) return;
    $scope.uploading = true;

    const fd = new $window.FormData();

    fd.append('image', files[0]);

    tlHttp
      .upload('/image?ignoreHeight=1', {}, fd)
      .success(function(data) {
        $scope.image = data;
        $scope.uploading = false;

        document.getElementById('input-img-upload').value = '';
      })
      .error(function() {
        $scope.uploading = false;

        document.getElementById('input-img-upload').value = '';
      });
  };

  $scope.clientMessageSocket = supportService.listenForClientMessages(function(message) {
    $scope.$apply(function() {
      events.emit(conciergeMessageReceivedKey, message);
      $scope.messages[message.id] = message;
      $timeout(function() {
        scrollToBottom(400);
      }, 100);
    });
  });

  $scope.$on('$destroy', function() {
    $scope.clientMessageSocket.close();
  });

  $scope.showIntroDescription = function() {
    return Object.keys($scope.messages).length === 0;
  };

  $scope.showConciergeDescription = function() {
    const messages = $scope.getMessages();

    if (!messages || messages.length === 0) return false;

    return !_.some(messages, function(message) {
      return message.from.userType === 'agent';
    });
  };

  function scrollToBottom(time) {
    const div = jQuery('.message-list');

    div.animate({
      scrollTop: div[0].scrollHeight
    }, time);
  }

  $scope.fetchMessages();

  $scope.clientMessageSocket.connect();
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  '$timeout',
  '$window',
  'tl.support.service',
  'tl.http',
  'tl.ee',
  'conciergeMessageReceivedKey',
  'trackingService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/conciergeChat/controller.js